<template>
    <div >
     <v-alert  v-if='peak'
      color="red"
      border="left"
      elevation="2"
      colored-border
      icon="mdi-alert"
    >
     You are in Peak Mode <v-icon>remove_red_eye</v-icon>
    </v-alert>

<v-dialog
      v-model="commentDialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Add new comment
        </v-card-title>

        <v-card-text>
          <v-textarea
          v-model='newComment'
           auto-grow  
          outlined
          class='mt-5 '
          label="GC Comments"
          placeholder="Enter comments here"
        ></v-textarea>
        </v-card-text>
           <v-card-actions>
             <v-spacer></v-spacer>
      <v-btn v-if='!currentComment' class='primary' @click='sendCommentToServer()'>Save Comment</v-btn>
      <v-btn v-if='currentComment' class='primary' @click='editComment()'>Edit Comment</v-btn>
      <v-btn v-if='currentComment' class='warning' @click='deleteComment()'>Remove</v-btn>
    </v-card-actions>
       
      </v-card>
    </v-dialog>


<!-- main content -->
  <v-card>
  <v-container  v-if='currentPatient' class="grey lighten-5">
    <p  class='grey--text display-1'>{{currentPatient.info.email}} </p>
    <p>user's last activity: {{currentPatient.lastUpdateInUtc ? $momentTz.tz(currentPatient.lastUpdateInUtc,'America/Los_Angeles').format("MM-DD-YYYY HH:mm:ss") : ""}}</p>
    <v-row>
      <v-col cols="8">
      <v-list-item three-line>
      <v-list-item-avatar size='100' color="grey"> <v-icon size='100' dark>mdi-account-circle</v-icon></v-list-item-avatar>
       
     <v-list-item-content>
        <v-list-item-title v-if='currentPatient.familyHistory.length > 0' class="headline">{{currentPatient.familyHistory[0].name}}</v-list-item-title>
         <v-list-item-subtitle>
           <p class='subtitle-1'><b>{{planName()}}</b></p>
           
           <composeMessage :userData='currentPatient'/>
            <v-btn class='primary ml-2'  small depressed @click="saveDatatoDB()"><v-icon class='mr-2'>save</v-icon> save changes</v-btn>
              <assignToButton :userUID='currentPatient.uid' />
      
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
         <pastMedicalHistory :currentPatient="currentPatient" />
        <br/>
          <pastSuricalHistory  :currentPatient="currentPatient" />
         <br/>
          <exposures :currentPatient="currentPatient" />
        <br/>
        <v-data-table :loading='isLoading' loading-text="Loading... Please wait" dense :headers="CommentsHeader" hide-default-footer :items="commentsList" item-key="time" class="elevation-1">
           <template v-slot:top> <v-toolbar flat color="white"> 
             <v-toolbar-title>GC comments</v-toolbar-title>  
             <v-spacer></v-spacer>
             <v-btn color="primary" @click='commentDialog = true;currentComment=null;newComment=null' dark class="mb-2" >Add new comment</v-btn>
             </v-toolbar>
             </template>
              <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editCommentInit(item)"
      >
        mdi-pencil
      </v-icon>
    </template>
        </v-data-table>
        
       
           <v-card
          class="mt-5 pa-2"
          outlined
          tile
        >
        <p>Manage report</p>
       
          <pdf v-if='currentPatient.familyHistory.length > 0' :patientData='currentPatient' :fileList='filesList'/>
            <div v-else>
               <p v-if='currentPatient.step'>User is currently on step: {{currentPatient.step}}</p>
                <p v-else class='red--text'>User's Family History is not yet started</p>
           <v-btn
        color="primary"
        disabled> Generate PDF report</v-btn>
            </div>
        </v-card>
       
      </v-col>
     
      <v-col  cols="4">
           <v-card
          class="pa-2"
          outlined
          tile
        >
        <p>Review Checklist</p>
         <v-badge 
      color="teal"
      right
      overlap
    >
      <template v-slot:badge>
        <v-icon v-if='currentPatient.report.familyHistoryComment' dark>
          mdi-check
        </v-icon>
      </template>
    <reviewFamilyHistory :currentPatient='currentPatient' />
    </v-badge>
    <div class='mt-3'>
      <v-badge 
      color="teal"
      right
      overlap
    >
      <template v-slot:badge>
        <v-icon v-if='currentPatient.report.pedigree' dark>
          mdi-check
        </v-icon>
      </template>
      <uploadDialog @uploadcomplete="fetchFileList" :uid='userID'/>
    </v-badge>
    </div>
         
        </v-card>
        <br/>
        <fileDialog @uploadcomplete="fetchFileList" :filesList='filesList'/>
        <br/>
        <userInfo :currentPatient='currentPatient' />
      </v-col>
     
    </v-row>
   
  </v-container>
      </v-card>
    </div>
</template>

<script>
import assignToButton from "../../components/assignToButton"
import composeMessage from "./composeMessageModal"
import reviewFamilyHistory from "../myTasks/newUsersModal/reviewFamilyHistory"
import pdf from "../../components/pdf"
import { mask } from 'vue-the-mask'
import { mapFields } from 'vuex-map-fields';
import { postReq} from '../../helper/firestore'
import fileDialog from '../../components/myTasks/newUsersModal/files'
import uploadDialog from "../../components/myTasks/newUsersModal/upload"
import pastMedicalHistory from "../../components/myTasks/newUsersModal/pastMedicalHistory"
import pastSuricalHistory from "../../components/myTasks/newUsersModal/pastSurgicalHistory"
import exposures from "../../components/myTasks/newUsersModal/exposures"
import userInfo from "../../components/myTasks/newUsersModal/userInfo"
export default {
  components : {
    pdf,composeMessage,fileDialog,reviewFamilyHistory,uploadDialog,pastMedicalHistory,pastSuricalHistory,exposures,userInfo,assignToButton
  },
  directives: {
      mask,
    },
    props : {
        userID : String,
        taskID : String,
    },
    data() {
        return {
          peak : false,
          isLoading: true,
          newComment : null,
          filesList : [],
          familyHistDialog  : false,
          commentDialog : false,
          PedigreeUploadFile : null,
          valid:true,
           formRules: [
        v => !!v || 'this field is required',
      ],
            statusItem : ["Ready","Need Additonal Info","Under Review"],
            resultItem : ["Positive","Negative"],
            confirmDialog : false,
            items: ['open', 'on hold', 'completed'],
            dialog : false,
            fileURL : null,
            commentsList : [],
            currentComment : null,
            currentPatient : null,
            CommentsHeader : [
              { text: 'Time', value: 'time'},
              { text: 'GC', value: 'gc'},
              { text: 'Comment', value : 'comment'},
               { text: 'Actions', value: 'actions', sortable: false },
            ]
        }
    },
    methods : {
      planName(){
        if(this.currentPatient){
          switch(this.currentPatient.plan){
            case "p1":
              return "Genetic Trust: Plus Plan";
            case "p1_couple": 
              return "Genetic Trust: Plus Plan for Couple";
                        case "p2":
              return "Genetic Trust: Complete Plan";
            case "p2_couple": 
              return "Genetic Trust: Complete Plan for Couple";
          }
        }else{
          return "";
        }
      }, 
      deleteComment(){
          postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/comment/removecomment',{id: this.currentComment.id},()=>{
          this.snackBarType = "success"
          this.snackBarshow = true
          this.snackBarmessage = "Comment deleted"
          this.commentDialog = false
          this.getCommentByUserID()
        })
      },
      editComment(){
         postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/comment/editcomment',{uid:this.userID,comment : this.newComment, id: this.currentComment.id},()=>{
          this.snackBarType = "success"
          this.snackBarshow = true
          this.snackBarmessage = "Comment edited"
          this.commentDialog = false
          this.getCommentByUserID()
        })
      },
      editCommentInit(item){
        this.currentComment = item ; 
        this.commentDialog = true; 
        this.newComment = item.comment
      },
      getCommentByUserID(){
        this.isLoading = true;
        postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/comment/getcomment',{uid:this.userID},result=>{
          this.commentsList = result.data
          this.isLoading = false;
        })
      },
      sendCommentToServer(){
           postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/comment/addcomment',{uid:this.userID,gc: this.user.email,comment:this.newComment,user : this.currentPatient.uid},()=>{
          this.snackBarType = "success"
          this.snackBarshow = true
          this.snackBarmessage = "Comment added"
          this.commentDialog = false
          this.getCommentByUserID()
        })
      },
      fetchFileList(){
          postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/patients/getPatientsFiles',{uid:this.userID},result=>{
          this.filesList = result.data
          this.filesList = this.filesList.sort((a,b)=>(a.metaData.timeCreated > b.metaData.timeCreated)? -1: 1);
        })
      },
  
      familyChecked(){
        return false
      },
      saveDatatoDB(){
        
        postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/savePatientsData',{idToken: this.user.idToken,user : this.userID,patientData :this.currentPatient},()=>{
          this.snackBarType = "success"
          this.snackBarshow = true
          this.snackBarmessage = "Update complete"
        })
          
      }
    },
  computed: {
    ...mapFields([
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
      'overlay'
    ]),
  },
    mounted(){
      
       if(window.location.hash) {
      var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
      hash === "peak" ? this.peak = true : this.peak = false;
      }
      this.overlay = true
     
      this.getCommentByUserID()
      postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/patients/getPatientById',{uid:this.userID},result=>{
            this.currentPatient = result.data
            this.fetchFileList()
            this.overlay = false
        })
    },
}
</script>

<style>

</style>
